export default {
  orderId: {
    id: 'bo_sellers-orders-components-filters-order_id',
    defaultMessage: 'Order Id',
  },
  startDate: {
    id: 'bo_sellers-orders-components-filters-start_date',
    defaultMessage: 'Start date',
  },
  endDate: {
    id: 'bo_sellers-orders-components-filters-end_date',
    defaultMessage: 'End date',
  },
  backShip: {
    id: 'bo_sellers-orders-components-filters-backship',
    defaultMessage: 'BackShip',
  },
  shippingProvider: {
    id: 'bo_sellers-orders-components-filters-shipping-provider',
    defaultMessage: 'Shipping provider',
  },
  withAndWithoutBackShip: {
    id: 'bo_sellers-orders-components-filters-with_and_without_backship',
    defaultMessage: 'With and without BackShip',
  },
  withBackShip: {
    id: 'bo_sellers-orders-components-filters-with_backship',
    defaultMessage: 'With BackShip',
  },
  withoutBackShip: {
    id: 'bo_sellers-orders-components-filters-without_backship',
    defaultMessage: 'Without BackShip',
  },
  sku: {
    id: 'bo_sellers-orders-components-filters-sku',
    defaultMessage: 'SKU',
  },
  customerFirstName: {
    id: 'bo_sellers-orders-components-filters-customer_first_name',
    defaultMessage: 'Customer first name',
  },
  customerLastName: {
    id: 'bo_sellers-orders-components-filters-customer_last_name',
    defaultMessage: 'Customer last name',
  },
  market: {
    id: 'bo_sellers-orders-components-filters-market',
    defaultMessage: 'Country',
  },
  orderState: {
    id: 'bo_sellers-orders-components-filters-order_state',
    defaultMessage: 'Order state',
  },
  dateType: {
    id: 'bo_sellers-orders-components-filters-date_type',
    defaultMessage: 'Date type',
  },
  orderLineId: {
    id: 'bo_sellers-orders-components-filters-order_line_id',
    defaultMessage: 'OrderLine Id',
  },
  submit: {
    id: 'bo_sellers-orders-components-filters-apply_filters',
    defaultMessage: 'Apply filters',
  },
  reset: {
    id: 'bo_sellers-orders-components-filters-reset_filters',
    defaultMessage: 'Reset filters',
  },
  filter: {
    id: 'bo_sellers-orders-components-filters-filter',
    defaultMessage: 'Filter',
  },
  viewResults: {
    id: 'bo_sellers-orders-components-filters-view_results',
    defaultMessage: 'View results',
  },
  startAndEndDate: {
    id: 'bo_sellers-orders-components-filters-start_and_end_date',
    defaultMessage: 'Start and end date',
  },
  customerName: {
    id: 'bo_sellers-orders-components-filters-customer_name',
    defaultMessage: 'Customer name',
  },
  all: {
    id: 'bo_sellers-orders-components-filters-all',
    defaultMessage: 'All',
  },
  missingAction: {
    id: 'bo_sellers-orders-components-filters-missing_action',
    defaultMessage: 'Missing action',
  },
} as const
